module.exports = __webpack_public_path__ + "img/logo.ac800e7c.png";